<template>
  <p class="mb-3">
    Not implemented.
  </p>
</template>

<script>
export default {
  name: 'PlayerPendingAddDataInputNotImplemented',

  methods: {
    fillFormData() {
      return new Error('Not implemented.');
    },      
  },
}
</script>
